module.exports = __webpack_public_path__ + "media/images/home/feature/management_requestlist-e151d9ff6e669049fdf7d11987afaf1b.png";